import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CorkBoardUIState {
  deletedThreadIds: string[];
  feedNeedsReplace: boolean;
}

const initialState: CorkBoardUIState = {
  deletedThreadIds: [],
  feedNeedsReplace: false,
};

const corkBoardUISlice = createSlice({
  name: 'corkBoardUI',
  initialState,
  reducers: {
    trackDeletedThread(state, action: PayloadAction<string>) {
      if (!state.deletedThreadIds.includes(action.payload)) {
        state.deletedThreadIds.push(action.payload);
      }
    },
    clearDeletedThreads(state) {
      state.deletedThreadIds = [];
    },
    markFeedForReplace(state) {
      state.feedNeedsReplace = true;
    },
    clearFeedReplace(state) {
      state.feedNeedsReplace = false;
    },
  },
});

export const { trackDeletedThread, clearDeletedThreads, markFeedForReplace, clearFeedReplace } = corkBoardUISlice.actions;
export default corkBoardUISlice.reducer;
